export const MetricsTrendChartData = [
  {
    "date": "20240930",
    "metrics": {
      "active_users": {
        "value": "3545.000000",
        "last_value": "3641.000000"
      },
      "new_users": {
        "value": "199.000000",
        "last_value": "213.000000"
      }
    }
  },
  {
    "date": "20241001",
    "metrics": {
      "active_users": {
        "value": "3475.000000",
        "last_value": "3640.000000"
      },
      "new_users": {
        "value": "163.000000",
        "last_value": "191.000000"
      }
    }
  },
  {
    "date": "20241002",
    "metrics": {
      "active_users": {
        "value": "3357.000000",
        "last_value": "3593.000000"
      },
      "new_users": {
        "value": "159.000000",
        "last_value": "196.000000"
      }
    }
  },
  {
    "date": "20241003",
    "metrics": {
      "active_users": {
        "value": "3350.000000",
        "last_value": "3571.000000"
      },
      "new_users": {
        "value": "196.000000",
        "last_value": "215.000000"
      }
    }
  },
  {
    "date": "20241004",
    "metrics": {
      "active_users": {
        "value": "3258.000000",
        "last_value": "3495.000000"
      },
      "new_users": {
        "value": "198.000000",
        "last_value": "180.000000"
      }
    }
  },
  {
    "date": "20241005",
    "metrics": {
      "active_users": {
        "value": "3320.000000",
        "last_value": "3583.000000"
      },
      "new_users": {
        "value": "221.000000",
        "last_value": "239.000000"
      }
    }
  },
  {
    "date": "20241006",
    "metrics": {
      "active_users": {
        "value": "3353.000000",
        "last_value": "3596.000000"
      },
      "new_users": {
        "value": "231.000000",
        "last_value": "245.000000"
      }
    }
  },
  {
    "date": "20241007",
    "metrics": {
      "active_users": {
        "value": "3287.000000",
        "last_value": "3545.000000"
      },
      "new_users": {
        "value": "180.000000",
        "last_value": "199.000000"
      }
    }
  },
  {
    "date": "20241008",
    "metrics": {
      "active_users": {
        "value": "3302.000000",
        "last_value": "3475.000000"
      },
      "new_users": {
        "value": "203.000000",
        "last_value": "163.000000"
      }
    }
  },
  {
    "date": "20241009",
    "metrics": {
      "active_users": {
        "value": "3130.000000",
        "last_value": "3357.000000"
      },
      "new_users": {
        "value": "133.000000",
        "last_value": "159.000000"
      }
    }
  },
  {
    "date": "20241010",
    "metrics": {
      "active_users": {
        "value": "3090.000000",
        "last_value": "3350.000000"
      },
      "new_users": {
        "value": "172.000000",
        "last_value": "196.000000"
      }
    }
  },
  {
    "date": "20241011",
    "metrics": {
      "active_users": {
        "value": "2980.000000",
        "last_value": "3258.000000"
      },
      "new_users": {
        "value": "208.000000",
        "last_value": "198.000000"
      }
    }
  },
  {
    "date": "20241012",
    "metrics": {
      "active_users": {
        "value": "3121.000000",
        "last_value": "3320.000000"
      },
      "new_users": {
        "value": "245.000000",
        "last_value": "221.000000"
      }
    }
  },
  {
    "date": "20241013",
    "metrics": {
      "active_users": {
        "value": "3089.000000",
        "last_value": "3353.000000"
      },
      "new_users": {
        "value": "217.000000",
        "last_value": "231.000000"
      }
    }
  }
];